import React from 'react';
import * as S from './ErrorText.styles';

export type IErrorProps = {
  error?: string;
};

export const ErrorText = ({ error }: IErrorProps) => {
  return <S.ErrorText error={error}>{error}</S.ErrorText>;
};
